import { create } from "zustand";
import axios from 'axios';


export const useManufacturer = create((set, get) => ({
    loader: false,
    allManufacturersResult: [],
    allManufacturersPagination: {},
    actions: {

        addRealStateConstructor: async (mobile, firstName, lastName, stateId, cityId, areaId,) => {
            set((state) => ({ loader: true }));
            try {
                const response = await axios.post(
                    'https://api.pelakeman.com/api/Constructor/AddConstructor',
                    {
                        mobile,
                        firstName,
                        lastName,
                        stateId,
                        cityId,
                        areaId
                    },
                    {
                        headers: {
                            accept: "text/plain",
                            "Content-Type": "application/json",
                            Authorization: `Bearer ${localStorage.getItem("pelakToken")}`,
                        },
                    }
                );
                

                set((state) => ({ loader: false }));
                return response.data; // Return the response data to the calling function
            } catch (error) {
                console.error("Error in API call:", error);
                set((state) => ({ loader: false }));
                set((state) => ({ showServerError: true }));
                throw error; // Rethrow the error to handle it in the calling function
            }
        },
        editRealStateConstructor: async (id, mobile, firstName, lastName, stateId, cityId, areaId) => {
            set((state) => ({ loader: true }));
            try {
                const response = await axios.post(
                    'https://api.pelakeman.com/api/Constructor/EditConstructor',
                    {
                        id,
                        mobile,
                        firstName,
                        lastName,
                        stateId,
                        cityId,
                        areaId,
                    },
                    {
                        headers: {
                            accept: "text/plain",
                            "Content-Type": "application/json",
                            Authorization: `Bearer ${localStorage.getItem("pelakToken")}`,
                        },
                    }
                );
                

                set((state) => ({ loader: false }));
                return response.data; // Return the response data to the calling function
            } catch (error) {
                console.error("Error in API call:", error);
                set((state) => ({ loader: false }));
                set((state) => ({ showServerError: true }));
                throw error; // Rethrow the error to handle it in the calling function
            }
        },
        getAllConstructors: async (id, mobile, firstName, lastName, searchQuery, userId, stateId, cityId, areaId, page, isDeleted) => {
            set((state) => ({ loader: true }))
            await axios.post('https://api.pelakeman.com/api/Constructor/GetAllConstructors', {
                "id": id,
                "mobile": mobile,
                "firstName": firstName,
                "lastName": lastName,
                "searchQuery": searchQuery,
                "userId": userId,
                "stateId": stateId,
                "cityId": cityId,
                "areaId": areaId,
                "page": page,
                "isDeleted": isDeleted,
            }, {
                headers: {
                    "accept": "text/plain",
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${localStorage.getItem("pelakToken")}`
                },
            })
                .then((res) => {



                    set((state) => ({ loader: false }))
                    set((state) => ({ allManufacturersResult: res.data.result }))
                    set((state) => ({ allManufacturersPagination: res.data.pagination }))
                }).catch(() => {
                    set((state) => ({ loader: false }))
                    set((state) => ({ showServerError: true }))
                })
        },

        deleteConstructor: async (id) => {

            await axios.post('https://api.pelakeman.com/api/Constructor/DeleteConstructor',
                { "id": id },
                {
                    headers: {
                        "accept": "text/plain",
                        "Content-Type": "application/json",
                        Authorization: `Bearer ${localStorage.getItem("pelakToken")}`
                    },
                })
                .then((res) => {
                    

                }).catch(() => {

                    set((state) => ({ showServerError: true }))
                })
        },
    }
}))